import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-support",
  templateUrl: "./support.component.html",
  styleUrls: ["./support.component.scss"],
})
export class SupportComponent implements OnInit {
  categoryContent: FormGroup;
  message = '';
  @ViewChild('submitBtn') submitBtn: ElementRef<HTMLButtonElement>;
  constructor(private _fb: FormBuilder, private _snackBar: MatSnackBar, private afs: AngularFirestore, private title: Title) { }

  ngOnInit(): void {
    // this.title.setTitle(`Support | Illusbook`);
    this.categoryContent = this._fb.group({
      emailId: [""],
      message: [""],
      category: ["", Validators.required],
      isActive: ["active"],
    });
  }


  async submitContent(data, valid) {
    //console.log(data);

    if (valid) {
      data["createdAt"] = new Date().toString();
      data["createdOn"] = +new Date();
      data['status'] = 'Pending';
      await this.afs.collection("supportMaster").add(data);
      this.categoryContent.reset({
        emailId: '',
        message: '',
        category: '',
        isActive: 'active'
      });
      // this.message = 'Submitted Successfully';
      // setTimeout(()=>{
      //   this.message = '';
      // }, 5000);
      this.submitBtn?.nativeElement.blur();
      this._snackBar.open("Added Successfully", "Ok", {
        duration: 1000,
      });
      return true;
    } else return false;
  }
}


